import { render, staticRenderFns } from "./ContactChip.vue?vue&type=template&id=6bc006a0&scoped=true"
import script from "./ContactChip.vue?vue&type=script&lang=js"
export * from "./ContactChip.vue?vue&type=script&lang=js"
import style0 from "./ContactChip.vue?vue&type=style&index=0&id=6bc006a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc006a0",
  null
  
)

export default component.exports